<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          章节
        </div>
        <el-cascader
          ref="cascader"
          v-model="cascaderInfo"
          :props="cascaderProps"
          :options="courseList"
          clearable
          @change="formatCourse"
        />
      </div>
      <div class="r">
        <el-link
          :href="downloadUrl"
          target="_blank"
        >
          <el-button
            type="primary"
          >
            导出试题
          </el-button>
        </el-link>
        <el-button
          type="default"
          @click="importExcelDialog"
        >
          导入试题
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <import-excel-dialog
      :dialog-visible.sync="excelDialogVisible"
      :list="courseList"
      @confirm="getList()"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types from '@/config';
import importExcelDialog from '@/components/common/importExcelDialog.vue';

const config = require('../../../httpConfig');

export default {
  name: 'Home',
  components: {
    dataTable,
    importExcelDialog,
  },
  data() {
    return {
      tabelData: {},
      courseList: [], // 章节列表
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        targetSonId: null,
        targetId: null,
      },
      excelDialogVisible: false,
      cascaderProps: {
        value: 'customizeId',
        label: 'customizeName',
        children: 'list',
      },
      cascaderInfo: '',
      tableColumn: [
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseChapterName',
          label: '章节名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'typeStr',
          label: '题型',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'topicContent',
          label: '题目',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'choiceA',
          label: '选项A',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'choiceB',
          label: '选项B',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'choiceC',
          label: '选项C',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'choiceD',
          label: '选项D',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'correctAnswerStr',
          label: '正确答案',
          width: '60px',
          dataType: 'text',
        },
        {
          key: 'isShow',
          label: '是否显示',
          width: '60px',
          dataType: 'component',
          renderProps: { [types.IS_USE]: '是', [types.IS_NO_USE]: '否', successKey: types.IS_USE },
          render: () => 'status',
        },
        {
          key: 'control',
          label: '操作',
          width: '120px',
          dataType: 'component',
          renderProps: [
            {
              text: '显示', renderKey: types.IS_NO_USE, renderProp: 'isShow', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '隐藏', renderKey: types.IS_USE, renderProp: 'isShow', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  computed: {
    downloadUrl() {
      let query1 = '';
      let query2 = '';
      if (this.searchForm.targetId) {
        query1 = `targetId=${this.searchForm.targetId}`;
      }
      if (this.searchForm.targetSonId) {
        query2 = `&targetSonId=${this.searchForm.targetSonId}`;
      }
      return `${process.env.VUE_APP_HOST_ENV === 'dev' ? config.dev : config.prod}/api/question/listExcelExport?${query1}${query2}`;
    },
  },
  mounted() {
    this.getList();
    this.getListCourseQuestionSelect();
  },
  methods: {
    // 获取课程列表
    async getListCourseQuestionSelect() {
      this.courseList = await axClient.test.listCourseQuestionSelect();
      this.courseList.forEach((course) => {
        this.$set(course, 'customizeId', course.courseId);
        this.$set(course, 'customizeName', course.courseName);
        if (course.chapterList) {
          course.chapterList.forEach((chapter) => {
            this.$set(chapter, 'customizeId', chapter.courseChapterId);
            this.$set(chapter, 'customizeName', chapter.courseChapterName);
          });
          this.$set(course, 'list', this._.cloneDeep(course.chapterList));
        }
      });
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.test.listPage(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.deleteTest(item);
          break;
        default:
          break;
      }
    },
    // 下架/上架 课程
    confirmDialog(item) {
      this.$confirm('确定显示/隐藏该试题？', '显示/隐藏试题', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, isShow } = item;
        const data = await axClient.test.updateIsShow(
          {
            id,
            isShow: isShow === types.IS_USE
              ? types.IS_NO_USE : types.IS_USE,
          },
        );
        if (data) {
          this.$message.success('显示/隐藏成功');
          this.getList();
        }
      });
    },
    // 删除试题
    deleteTest(item) {
      this.$confirm('确定删除该试题？', '删除试题', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { id } = item;
        const data = await axClient.test.deleteById(
          {
            id,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // 处理章节
    formatCourse() {
      const targetSonId = this.cascaderInfo[1];
      const targetId = this.cascaderInfo[0];
      this.searchForm = Object.assign(this.searchForm, { targetSonId, targetId });
      this.getList();
    },
    // 打开导入弹窗
    importExcelDialog() {
      this.excelDialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
